import { APIResponse } from 'src/app/core/http/http.model';
import { HttpService } from 'src/app/core/http/http.service';
import { Professional } from 'src/app/core/models/professional.model';
import { EnumProfiles } from 'src/app/shared/enums/enums';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { IUser } from 'src/app/core/models/user.model';
import { QuestionnairesService } from './questionnaires.service';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { Store } from '@ngrx/store';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { QuestionariType } from '../model/questionnaire-response';
import { Errors, ErrorType } from 'src/app/shared/enums/error';

@Injectable({
  providedIn: 'root'
})
export class RamService {

  private patientSelectedId: string | null = null;
  private ramSubject = new BehaviorSubject<any>(null);

  subscription!: Subscription;
  userLogged: IUser | null = null;

  constructor(
    private questionnairesService: QuestionnairesService,
    private store: Store<AuthState>,
    private patientInfoService: PatientService,
    private httpService: HttpService,) {
    this.ramSubject.next(null);

    this.subscription = (
      combineLatest([
        this.store.select(getAuthStateSelect),
        this.patientInfoService.getPatientId()
      ])
        .subscribe(([auth, patientId]) => {
          if (!auth.user || !patientId) return;

          this.userLogged = auth.user;
          this.patientSelectedId = patientId;
        }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getRAM() {
    return this.ramSubject.asObservable();
  }

  async loadRAM(patientId: string, user: IUser): Promise<void> {

    this.ramSubject.next(null);
    await this.questionnairesService.getQuestionnaires(
      'ram', patientId, user.practitionerId)
      .then((result: any) => {
        if (result) {
          this.ramSubject.next({
            ...result,
            history: [...(result?.history ?? [])],
            myclinicHistory: [...(result?.myclinicHistory ?? [])],
            today: { ...result?.today }
          });
        }
      });
  }

  async saveRAM({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.saveNewQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadRAM(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao salvar questionário de RAM.',
        error
      );
    }
  }

  async updateRAM({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.updateQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadRAM(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao atualizar questionário de RAM.',
        error
      );
    }
  }

  async getProfessionals(profile: EnumProfiles): Promise<APIResponse<Professional[]>> {

    try {
      const apiResult = await this.httpService.req<any>('userByProfile', 'patient', {
        apiVersion: 2,
        params: {
          profile,
          lg: 'pt-BR'
        },
        method: 'get'
      });

      return apiResult;
    }
    catch (error) {

      throw error;
    }
  }
}
